

//! bu duruma göre belki silinebilir
const getDistance = async (origin, destination, waypoints) => {

    // eslint-disable-next-line no-undef
    const directionsService = new window.google.maps.DirectionsService()
    const results = await directionsService.route({
    origin: origin,
    destination: destination,
    waypoints: waypoints,
    // eslint-disable-next-line no-undef
    travelMode: google.maps.TravelMode.DRIVING,
    })

    const legs = results.routes[0].legs

    const distance = legs.reduce((accumulator, item) =>  {
        return accumulator + parseFloat(item.distance.text.replace(".", ""))
    },0)

    return distance
}

export default getDistance